import { render, staticRenderFns } from "./DatasetAttributes.vue?vue&type=template&id=1fdcd307"
import script from "./DatasetAttributes.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetAttributes.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports